import { lazy, Suspense, useState } from "react";
import { Calculator, ChevronDown, ChevronRight, Loader2 } from "lucide-react";

const CalculationEditor = lazy(() => import("@/components/calculations/CalculationEditor"));

/**
 * Order → Calculation section (Block 5.1, FIT flow). Collapsed by default — the editor
 * (params, items, live results, generate-order-items) lazy-loads on first expand so the
 * order detail stays light. Anchored to the order: pax prefills from the order's heads,
 * marginMode defaults to "commission" (FIT-DMC label), and the editor's
 * "Generate order items…" writes the sell lines through syncOrderItems.
 */
export default function CalculationPanel({ orderId }: { orderId: string }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="card">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="flex w-full items-center gap-2 text-left"
      >
        {open ? (
          <ChevronDown className="h-4 w-4 text-gray-400" />
        ) : (
          <ChevronRight className="h-4 w-4 text-gray-400" />
        )}
        <Calculator className="text-primary-500 h-5 w-5" />
        <h2 className="text-lg font-semibold text-gray-900 dark:text-white">
          Calculation (pricing)
        </h2>
      </button>
      {open && (
        <div className="mt-4">
          <Suspense
            fallback={
              <div className="flex h-24 items-center justify-center">
                <Loader2 className="text-primary-600 h-6 w-6 animate-spin" />
              </div>
            }
          >
            <CalculationEditor orderId={orderId} />
          </Suspense>
        </div>
      )}
    </div>
  );
}
